import { useTransactionItemsInfiniteQuery } from 'features/transactions';
import { DonorsHorizontalCard } from '../donors-horizontal-card';
import { DonationsSkeletonRow } from '../skeletons';

type P = {
  givingId: string;
};

const TopDonors = ({ givingId }: P) => {
  const { data: topDonorsData, isLoading } = useTransactionItemsInfiniteQuery({
    filter: { order: 'amount', scope: 'highest', subjectId: givingId, subjectType: 'Giving' },
    pagination: { pageSize: 3 },
  });

  const topDonorsPayment = topDonorsData?.pages.flat().flatMap((givingsPaginated) => givingsPaginated.data);
  return (
    <>
      {isLoading ? (
        <DonationsSkeletonRow length={3} />
      ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
      topDonorsPayment?.length ? (
        <DonorsHorizontalCard donorsPayment={topDonorsPayment} title="Top donors" />
      ) : null}
    </>
  );
};

export default TopDonors;
